import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _get from 'lodash/get';
import React, { Component } from 'react';
import classes from './LogCard.module.css';
import Dialogue from 'components/UI/Dialogue/Dialogue';
import LogEdit from 'containers/ManageLogs/LogEdit/LogEdit';
import { getRgbFromColorName, truncateText } from 'shared/utility';

class LogCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderedDialogue: null,
      editingMemberId: null,
      flipperHeight: '109px',
      isEditing: false,
    };
  }

  componentDidMount() {
    this.setFlipperHeight(this.state.isEditing);
    this.setState({ renderedDialogue: null, editingMemberId: null, isEditing: false });
  }

  componentDidUpdate(prevProps) {
    if (this.props.log && prevProps.log && this.props.log.Log.Id !== prevProps.log.Log.Id) {
      this.setState({ isEditing: false, renderedDialogue: null, editingMemberId: null });
      this.setFlipperHeight(this.state.isEditing);
    }
    if (this.props.members !== prevProps.members) {
      this.setFlipperHeight(this.state.isEditing);
    }
  }

  handleRemoveUserFromLog = (keepPosts) => {
    this.props.handleLogAddRemoveMembers(this.props.log.Log.Id, null, null, null, [this.state.editingMemberId], keepPosts);
    this.setState({ renderedDialogue: null, editingMemberId: null });
  };

  handleLogRemoveArchivedMember = () => {
    this.props.handleLogRemoveArchivedMember(this.props.log.Log.Id, [this.state.editingMemberId]);
    this.setState({ renderedDialogue: null, editingMemberId: null });
  };

  handleToggleDialogue = (dialogueName) => {
    const updatedRenderedDialogue = this.state.renderedDialogue === dialogueName ? null : dialogueName;
    this.setState({ renderedDialogue: updatedRenderedDialogue });
  };

  handleSetEditingMemberId = (editingMemberId) => {
    this.setState({ editingMemberId });
  };

  // The card flipper requires that we determine that we set the flipper height.
  // If we don't do that the card and/or the contents below the card with get cut off.
  setFlipperHeight = (isEditing, removeUserAccordianExpanded) => {
    const cardId = isEditing ? 'edit-card' : 'view-card';
    let cardHeight = document.getElementById(cardId) ? document.getElementById(cardId).offsetHeight : 0;
    // We have to manually add/subtract the height of the removeUserAccordian when it is expaned / contracted
    if (typeof removeUserAccordianExpanded === 'boolean') cardHeight = removeUserAccordianExpanded ? cardHeight + 89 : cardHeight - 89;
    cardHeight = `${cardHeight}px`;
    this.setState({ flipperHeight: cardHeight });
  };

  toggleEditor = () => {
    this.setState({ isEditing: !this.state.isEditing });
    this.setFlipperHeight(!this.state.isEditing);
  };

  toggleMemberEdit = (memberId) => {
    const updatedMemberId = this.state.editingMemberId === memberId ? null : memberId;
    this.setState({ editingMemberId: updatedMemberId });
  };

  handleLogTransferHost = () => {
    const coHost = this.props.members.find((member) => member.Access === 'Co-host')
      ? this.props.members.find((member) => member.Access === 'Co-host')
      : null;
    if (coHost) {
      this.props.handleLogTransferHost(this.props.log.Log.Id, coHost.UserId);
      this.setState({ renderedDialogue: null });
    }
  };

  handleMemberPlusToMemberAccessUpdate = () => {
    this.props.handleLogMemberAccessUpdate(this.props.log.Log.Id, this.props.postingAs.UserId, 'Member');
    this.setState({ renderedDialogue: null });
  };

  handleLogDeletion = () => {
    this.props.handleLogDeletion(this.props.log.Log.Id);
    this.setState({ renderedDialogue: null });
  };

  render = () => {
    const flipContainerClasses = this.state.isEditing ? [classes.FlipContainer, classes.isFlipped].join(' ') : classes.FlipContainer;
    const logName = this.props.log && this.props.log.Log.Name ? this.props.log.Log.Name : null;
    // const isHost = this.props.log && this.props.log.Log.CreatedById === this.props.postingAs.UserId;
    const isPrivateLog = this.props.log && this.props.log.Log.Visibility === 'Private';
    const isSelf = this.props.postingAs && this.state.editingMemberId === this.props.postingAs.UserId;
    const coHost = this.props.members.find((member) => member.Access === 'Co-host')
      ? this.props.members.find((member) => member.Access === 'Co-host')
      : null;
    // const host = this.props.members.find((member) => member.Access === 'Host') ?
    // this.props.members.find((member) => member.Access === 'Host') : null;

    let confirmationDialogue = null;
    if (this.state.renderedDialogue === 'RemoveMemberAndContent') {
      confirmationDialogue = (
        <Dialogue
          subject="REMOVE ALL CONTENT"
          message={
            `If you remove all of ${isSelf ? 'your' : "this person's"}content from this log, the members OF THIS LOG will` +
            'no longer be able to view or contribute to those posts. This cannot be undone! This action should only be chosen with careful ' +
            'consideration.<br />Are you sure?'
          }
          cancelText="Cancel"
          className="EditLog"
          dialogueType="alertDialogue"
          whiteBackground
          cancelled={() => this.setState({ renderedDialogue: null, editingMemberId: null })}
          confirmationText="YES"
          confirm={() => this.handleRemoveUserFromLog(false)}
        />
      );
    } else if (this.state.renderedDialogue === 'RemoveMemberKeepContent') {
      confirmationDialogue = (
        <Dialogue
          subject={isSelf ? 'Remove Yourself, Keep Content' : 'Remove Member, Keep Content'}
          message={
            isSelf
              ? 'You will no longer be an active member of this log. All of your content will remain. ' +
                'You will still be able to view, edit, delete or remove individual posts from this log.'
              : 'This person will no longer be an active member of this log. All of this member’s content will remain. ' +
                'They will still be able to view, edit, delete or remove individual posts from this log.'
          }
          cancelText="Cancel"
          className="EditLog"
          whiteBackground
          cancelled={() => this.setState({ renderedDialogue: null, editingMemberId: null })}
          confirmationText="OK"
          confirm={() => this.handleRemoveUserFromLog(true)}
        />
      );
    } else if (this.state.renderedDialogue === 'DeleteArchivedMember') {
      confirmationDialogue = (
        <Dialogue
          subject="REMOVE ALL CONTENT"
          message={
            <>
              If you remove all of this person’s content from this log, the members OF THIS LOG will no longer be able to view or contribute to those
              posts. The member will no longer appear as an archived member. This cannot be undone! This action should only be chosen with careful
              consideration. <br />
              Are you sure?
            </>
          }
          cancelText="Cancel"
          className="EditLog"
          whiteBackground
          cancelled={() => this.setState({ renderedDialogue: null, editingMemberId: null })}
          confirmationText="OK"
          confirm={() => this.handleLogRemoveArchivedMember()}
        />
      );
    } else if (this.state.renderedDialogue === 'DeleteLog') {
      confirmationDialogue = (
        <Dialogue
          subject="Delete Log"
          message={
            <>
              Are you sure you want to DELETE this LOG? If so, each member’s personal content will remain in their personal log but that content will
              no longer be shared with the other members of that log.
            </>
          }
          cancelText="Cancel"
          className="EditLog"
          dialogueType="alertDialogue"
          whiteBackground
          cancelled={() => this.setState({ renderedDialogue: null })}
          confirmationText="YES"
          confirm={this.handleLogDeletion}
        />
      );
    } else if (this.state.renderedDialogue === 'CoHostRequiredForTransfer') {
      confirmationDialogue = (
        <Dialogue
          subject="Need Co-host"
          message="To transfer this log you must first choose a co-host. "
          className="EditLog"
          whiteBackground
          confirm={() => this.setState({ renderedDialogue: null })}
          confirmationText="OK"
        />
      );
    } else if (this.state.renderedDialogue === 'ConfirmTransfer') {
      confirmationDialogue = (
        <Dialogue
          subject="New Host"
          message={
            coHost
              ? `${coHost.FirstName}, the co-host for this log, will become the host and will receive a notification.`
              : 'co-host for this log, will become the host and will receive a notification.'
          }
          className="EditLog"
          whiteBackground
          cancelled={() => this.setState({ renderedDialogue: null })}
          confirm={this.handleLogTransferHost}
          cancelText="CANCEL"
          confirmationText="OK"
        />
      );
    } else if (this.state.renderedDialogue === 'LogAlreadyHasCoHost') {
      confirmationDialogue = (
        <Dialogue
          subject="Co-host Already Exists"
          message="To choose a new co-host, you must first change the status of your current co-host to a member or member+"
          className="EditLog"
          whiteBackground
          confirm={() => this.setState({ renderedDialogue: null })}
          confirmationText="OK"
        />
      );
    } else if (this.state.renderedDialogue === 'MemberPlusToMember') {
      confirmationDialogue = (
        <Dialogue
          subject="Member Permissions Status"
          message={
            <>
              Once you leave the Member+ level, you will not be able to add new members to this log. You can ask the Host or Co-host to change your
              status in the future
            </>
          }
          className="EditLog"
          whiteBackground
          cancelled={() => this.setState({ renderedDialogue: null })}
          cancelText="CANCEL"
          confirm={this.handleMemberPlusToMemberAccessUpdate}
          confirmationText="OK"
        />
      );
    }

    return (
      <div>
        {confirmationDialogue}
        <div id="flipper" style={{ height: this.state.flipperHeight }} className={flipContainerClasses}>
          <div className={classes.Flipper}>
            <div id="view-card" className={[classes.LogCard, classes.Front].join(' ')}>
              <h2 className={logName ? classes.LogName : [classes.LogName, classes.Placeholder].join(' ')}>
                {logName ? truncateText(logName, 50) : 'Untitled'}
              </h2>
              {!isPrivateLog ? (
                <FontAwesomeIcon icon="cog" onClick={this.toggleEditor} className={classes.EditIcon} />
              ) : !this.props.created ? (
                <button
                  className={logName ? classes.CreateLog : [classes.CreateLog, classes.Disabled].join(' ')}
                  onClick={logName ? this.props.handleLogCreation : undefined}
                >
                  Save
                </button>
              ) : null}
              <div className={classes.MembersList}>
                {this.props.members.map((member, i) => {
                  const imageURL = _get(member, 'ImageURL', _get(member, 'ThumbURL'));
                  return (
                    <div key={`member-${i}`} className={classes.Member}>
                      {imageURL ? (
                        <img
                          src={imageURL}
                          alt={`${member.FirstName}'s photo`}
                          className={classes.ProfileImage}
                          style={{
                            border: `3px solid ${member.Color ? getRgbFromColorName(member.Color) : 'rgb(108, 162, 183)'}`,
                            backgroundColor: member.Color ? getRgbFromColorName(member.Color) : 'rgb(108, 162, 183)',
                          }}
                        />
                      ) : (
                        <div
                          className={classes.AvatarContainer}
                          style={{ backgroundColor: member.Color ? getRgbFromColorName(member.Color) : 'rgb(108, 162, 183)' }}
                        >
                          <FontAwesomeIcon icon="user" className={classes.AvatarIcon} />
                        </div>
                      )}
                      <div className={classes.MemberDetails}>
                        <p className={classes.MemberName}>{`${member.FirstName} ${member.LastName}`}</p>
                        <p className={classes.MemberRole}>{member.Access}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div id="edit-card" className={[classes.Back, classes.LogCard, classes.Edit].join(' ')}>
              <LogEdit
                isCreated={this.props.created}
                members={this.props.members}
                log={this.props.log}
                postingAs={this.props.postingAs}
                isManagedUser={this.props.isManagedUser}
                editingMemberId={this.state.editingMemberId}
                error={this.props.error}
                addMembersVisible={this.props.addMembersVisible}
                handleLogNameUpdate={this.props.handleLogNameUpdate}
                handleLogDeletion={this.handleLogDeletion}
                handleToggleDialogue={this.handleToggleDialogue}
                handleSetEditingMemberId={this.handleSetEditingMemberId}
                toggleMemberEdit={this.toggleMemberEdit}
                handleAddMembersToggle={this.props.handleAddMembersToggle}
                handleLogMemberAccessUpdate={this.props.handleLogMemberAccessUpdate}
                done={this.toggleEditor}
                setFlipperHeight={this.setFlipperHeight}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
}

export default LogCard;
